import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { APP_PATHS } from '@core/constants';
import { TranslateModule } from '@ngx-translate/core';
import { FedDevice } from '../../fed-devices';

@Component({
  selector: 'xemex-installation-activity-empty',
  imports: [RouterLink, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './installation-activity-empty.component.html',
})
export class InstallationActivityEmptyComponent {
  devices = input.required<FedDevice[]>();

  protected readonly APP_PATHS = APP_PATHS;
}
